export const markets = [
  { value: '', left: 'All markets', right: '' },
  { value: 'es-AR', left: 'Argentina', right: 'Spanish' },
  { value: 'en-AU', left: 'Australia', right: 'English' },
  { value: 'de-AT', left: 'Austria', right: 'German' },
  { value: 'nl-BE', left: 'Belgium', right: 'Dutch' },
  { value: 'fr-BE', left: 'Belgium', right: 'French' },
  { value: 'pt-BR', left: 'Brazil', right: 'Portuguese' },
  { value: 'en-CA', left: 'Canada', right: 'English' },
  { value: 'fr-CA', left: 'Canada', right: 'French' },
  { value: 'es-CL', left: 'Chile', right: 'Spanish' },
  { value: 'da-DK', left: 'Denmark', right: 'Danish' },
  { value: 'fi-FI', left: 'Finland', right: 'Finnish' },
  { value: 'fr-FR', left: 'France', right: 'French' },
  { value: 'de-DE', left: 'Germany', right: 'German' },
  { value: 'zh-HK', left: 'Hong Kong', right: 'Chinese' },
  { value: 'en-IN', left: 'India', right: 'English' },
  { value: 'en-ID', left: 'Indonesia', right: 'English' },
  { value: 'it-IT', left: 'Italy', right: 'Italian' },
  { value: 'ja-JP', left: 'Japan', right: 'Japanese' },
  { value: 'ko-KR', left: 'Korea', right: 'Korean' },
  { value: 'en-MY', left: 'Malaysia', right: 'English' },
  { value: 'es-MX', left: 'Mexico', right: 'Spanish' },
  { value: 'nl-NL', left: 'Netherlands', right: 'Dutch' },
  { value: 'en-NZ', left: 'New Zealand', right: 'English' },
  { value: 'no-NO', left: 'Norway', right: 'Norwegian' },
  { value: 'zh-CN', left: 'China', right: 'Chinese' },
  { value: 'pl-PL', left: 'Poland', right: 'Polish' },
  { value: 'en-PH', left: 'Philippines', right: 'English' },
  { value: 'ru-RU', left: 'Russia', right: 'Russian' },
  { value: 'en-ZA', left: 'South Africa', right: 'English' },
  { value: 'es-ES', left: 'Spain', right: 'Spanish' },
  { value: 'sv-SE', left: 'Sweden', right: 'Swedish' },
  { value: 'fr-CH', left: 'Switzerland', right: 'French' },
  { value: 'de-CH', left: 'Switzerland', right: 'German' },
  { value: 'zh-TW', left: 'Taiwan', right: 'Chinese' },
  { value: 'tr-TR', left: 'Turkey', right: 'Turkish' },
  { value: 'en-GB', left: 'United Kingdom', right: 'English' },
  { value: 'en-US', left: 'United States', right: 'English' },
  { value: 'es-US', left: 'United States', right: 'Spanish' },
].map(({ value, left, right }) => ({
  value,
  label: `${left} ${right}`,
}));

export const regions = [
  { value: 'ae', label: 'United Arab Emirates' },
  { value: 'ag', label: 'Antigua and Barbuda' },
  { value: 'ai', label: 'Anguilla' },
  { value: 'al', label: 'Albania' },
  { value: 'am', label: 'Armenia' },
  { value: 'ao', label: 'Angola' },
  { value: 'ar', label: 'Argentina' },
  { value: 'at', label: 'Austria' },
  { value: 'au', label: 'Australia' },
  { value: 'az', label: 'Azerbaijan' },
  { value: 'bb', label: 'Barbados' },
  { value: 'bd', label: 'Bangladesh' },
  { value: 'be', label: 'Belgium' },
  { value: 'bf', label: 'Burkina-Faso' },
  { value: 'bg', label: 'Bulgaria' },
  { value: 'bh', label: 'Bahrain' },
  { value: 'bj', label: 'Benin' },
  { value: 'bm', label: 'Bermuda' },
  { value: 'bn', label: 'Brunei Darussalam' },
  { value: 'bo', label: 'Bolivia' },
  { value: 'br', label: 'Brazil' },
  { value: 'bs', label: 'Bahamas' },
  { value: 'bt', label: 'Bhutan' },
  { value: 'bw', label: 'Botswana' },
  { value: 'by', label: 'Belarus' },
  { value: 'bz', label: 'Belize' },
  { value: 'ca', label: 'Canada' },
  { value: 'ch', label: 'Switzerland' },
  { value: 'cl', label: 'Chile' },
  { value: 'cn', label: 'China' },
  { value: 'co', label: 'Colombia' },
  { value: 'cr', label: 'Costa Rica' },
  { value: 'cv', label: 'Cape Verde' },
  { value: 'cy', label: 'Cyprus' },
  { value: 'cz', label: 'Czech Republic' },
  { value: 'de', label: 'Germany' },
  { value: 'dk', label: 'Denmark' },
  { value: 'dm', label: 'Dominica' },
  { value: 'do', label: 'Dominican Republic' },
  { value: 'dz', label: 'Algeria' },
  { value: 'ec', label: 'Ecuador' },
  { value: 'ee', label: 'Estonia' },
  { value: 'eg', label: 'Egypt' },
  { value: 'es', label: 'Spain' },
  { value: 'fi', label: 'Finland' },
  { value: 'fj', label: 'Fiji' },
  { value: 'fr', label: 'France' },
  { value: 'gb', label: 'United Kingdom' },
  { value: 'gd', label: 'Grenada' },
  { value: 'gh', label: 'Ghana' },
  { value: 'gm', label: 'Gambia' },
  { value: 'gr', label: 'Greece' },
  { value: 'gt', label: 'Guatemala' },
  { value: 'gw', label: 'Guinea Bissau' },
  { value: 'gy', label: 'Guyana' },
  { value: 'hk', label: 'Hong Kong' },
  { value: 'hn', label: 'Honduras' },
  { value: 'hr', label: 'Croatia' },
  { value: 'hu', label: 'Hungaria' },
  { value: 'id', label: 'Indonesia' },
  { value: 'ie', label: 'Ireland' },
  { value: 'il', label: 'Israel' },
  { value: 'in', label: 'India' },
  { value: 'is', label: 'Iceland' },
  { value: 'it', label: 'Italy' },
  { value: 'jm', label: 'Jamaica' },
  { value: 'jo', label: 'Jordan' },
  { value: 'jp', label: 'Japan' },
  { value: 'ke', label: 'Kenya' },
  { value: 'kg', label: 'Krygyzstan' },
  { value: 'kh', label: 'Cambodia' },
  { value: 'kr', label: 'South Korea' },
  { value: 'kw', label: 'Kuwait' },
  { value: 'ky', label: 'Cayman Islands' },
  { value: 'kz', label: 'Kazakhstan' },
  { value: 'la', label: 'Laos' },
  { value: 'lb', label: 'Lebanon' },
  { value: 'lc', label: 'Saint Lucia' },
  { value: 'lk', label: 'Sri Lanka' },
  { value: 'lr', label: 'Liberia' },
  { value: 'lt', label: 'Lithuania' },
  { value: 'lu', label: 'Luxembourg' },
  { value: 'lv', label: 'Latvia' },
  { value: 'md', label: 'Moldova' },
  { value: 'mg', label: 'Madagascar' },
  { value: 'mk', label: 'Macedonia' },
  { value: 'ml', label: 'Mali' },
  { value: 'mn', label: 'Mongolia' },
  { value: 'mo', label: 'Macau' },
  { value: 'mr', label: 'Mauritania' },
  { value: 'ms', label: 'Montserrat' },
  { value: 'mt', label: 'Malta' },
  { value: 'mu', label: 'Mauritius' },
  { value: 'mw', label: 'Malawi' },
  { value: 'mx', label: 'Mexico' },
  { value: 'my', label: 'Malaysia' },
  { value: 'mz', label: 'Mozambique' },
  { value: 'na', label: 'Namibia' },
  { value: 'ne', label: 'Niger' },
  { value: 'ng', label: 'Nigeria' },
  { value: 'ni', label: 'Nicaragua' },
  { value: 'nl', label: 'Netherlands' },
  { value: 'no', label: 'Norway' },
  { value: 'np', label: 'Nepal' },
  { value: 'nz', label: 'New Zealand' },
  { value: 'om', label: 'Oman' },
  { value: 'pa', label: 'Panama' },
  { value: 'pe', label: 'Peru' },
  { value: 'pg', label: 'Papua New Guinea' },
  { value: 'ph', label: 'Philippines' },
  { value: 'pk', label: 'Pakistan' },
  { value: 'pl', label: 'Poland' },
  { value: 'pt', label: 'Portugal' },
  { value: 'pw', label: 'Palau' },
  { value: 'py', label: 'Paraguay' },
  { value: 'qa', label: 'Qatar' },
  { value: 'ro', label: 'Romania' },
  { value: 'ru', label: 'Russia' },
  { value: 'sa', label: 'Saudi Arabia' },
  { value: 'sb', label: 'Soloman Islands' },
  { value: 'sc', label: 'Seychelles' },
  { value: 'se', label: 'Sweden' },
  { value: 'sg', label: 'Singapore' },
  { value: 'si', label: 'Slovenia' },
  { value: 'sk', label: 'Slovakia' },
  { value: 'sl', label: 'Sierra Leone' },
  { value: 'sn', label: 'Senegal' },
  { value: 'so', label: 'Somalia' },
  { value: 'sr', label: 'Suriname' },
  { value: 'sv', label: 'El Salvador' },
  { value: 'sz', label: 'Swaziland' },
  { value: 'td', label: 'Chad' },
  { value: 'th', label: 'Thailand' },
  { value: 'tj', label: 'Tajikistan' },
  { value: 'tm', label: 'Turkmenistan' },
  { value: 'tn', label: 'Tunisia' },
  { value: 'tr', label: 'Turkey' },
  { value: 'tw', label: 'Taiwan' },
  { value: 'tz', label: 'Tanzania' },
  { value: 'ua', label: 'Ukraine' },
  { value: 'ug', label: 'Uganda' },
  { value: 'us', label: 'United States' },
  { value: 'uy', label: 'Uruguay' },
  { value: 'uz', label: 'Uzbekistan' },
  { value: 've', label: 'Venezuela' },
  { value: 'vg', label: 'British Virgin Islands' },
  { value: 'vn', label: 'Vietnam' },
  { value: 'ye', label: 'Yemen' },
  { value: 'za', label: 'South Africa' },
  { value: 'zw', label: 'Zimbabwe' },
];

export const listenNotesRegions = [
  { value: '', label: 'Any region' },
  { value: 'ae', label: 'United Arab Emirates' },
  { value: 'al', label: 'Albania' },
  { value: 'am', label: 'Armenia' },
  { value: 'ar', label: 'Argentina' },
  { value: 'at', label: 'Austria' },
  { value: 'au', label: 'Australia' },
  { value: 'az', label: 'Azerbaijan' },
  { value: 'be', label: 'Belgium' },
  { value: 'bg', label: 'Bulgaria' },
  { value: 'bh', label: 'Bahrain' },
  { value: 'bn', label: 'Brunei Darussalam' },
  { value: 'bo', label: 'Bolivia' },
  { value: 'br', label: 'Brazil' },
  { value: 'by', label: 'Belarus' },
  { value: 'bz', label: 'Belize' },
  { value: 'ca', label: 'Canada' },
  { value: 'ch', label: 'Switzerland' },
  { value: 'cl', label: 'Chile' },
  { value: 'cn', label: 'China' },
  { value: 'co', label: 'Colombia' },
  { value: 'cr', label: 'Costa Rica' },
  { value: 'cz', label: 'Czech Republic' },
  { value: 'de', label: 'Germany' },
  { value: 'dk', label: 'Denmark' },
  { value: 'do', label: 'Dominican Republic' },
  { value: 'dz', label: 'Algeria' },
  { value: 'ec', label: 'Ecuador' },
  { value: 'ee', label: 'Estonia' },
  { value: 'eg', label: 'Egypt' },
  { value: 'es', label: 'Spain' },
  { value: 'fi', label: 'Finland' },
  { value: 'fr', label: 'France' },
  { value: 'gb', label: 'United Kingdom' },
  { value: 'gr', label: 'Greece' },
  { value: 'gt', label: 'Guatemala' },
  { value: 'hk', label: 'Hong Kong' },
  { value: 'hn', label: 'Honduras' },
  { value: 'hr', label: 'Croatia' },
  { value: 'hu', label: 'Hungary' },
  { value: 'id', label: 'Indonesia' },
  { value: 'ie', label: 'Ireland' },
  { value: 'il', label: 'Israel' },
  { value: 'in', label: 'India' },
  { value: 'is', label: 'Iceland' },
  { value: 'it', label: 'Italy' },
  { value: 'jm', label: 'Jamaica' },
  { value: 'jo', label: 'Jordan' },
  { value: 'jp', label: 'Japan' },
  { value: 'ke', label: 'Kenya' },
  { value: 'kr', label: 'South Korea' },
  { value: 'kw', label: 'Kuwait' },
  { value: 'kz', label: 'Kazakhstan' },
  { value: 'lb', label: 'Lebanon' },
  { value: 'lt', label: 'Lithuania' },
  { value: 'lu', label: 'Luxembourg' },
  { value: 'lv', label: 'Latvia' },
  { value: 'mk', label: 'Macedonia' },
  { value: 'mn', label: 'Mongolia' },
  { value: 'mo', label: 'Macau' },
  { value: 'mt', label: 'Malta' },
  { value: 'mx', label: 'Mexico' },
  { value: 'my', label: 'Malaysia' },
  { value: 'ng', label: 'Nigeria' },
  { value: 'ni', label: 'Nicaragua' },
  { value: 'nl', label: 'Netherlands' },
  { value: 'no', label: 'Norway' },
  { value: 'nz', label: 'New Zealand' },
  { value: 'om', label: 'Oman' },
  { value: 'pa', label: 'Panama' },
  { value: 'pe', label: 'Peru' },
  { value: 'ph', label: 'Philippines' },
  { value: 'pk', label: 'Pakistan' },
  { value: 'pl', label: 'Poland' },
  { value: 'pt', label: 'Portugal' },
  { value: 'py', label: 'Paraguay' },
  { value: 'qa', label: 'Qatar' },
  { value: 'ro', label: 'Romania' },
  { value: 'ru', label: 'Russia' },
  { value: 'sa', label: 'Saudi Arabia' },
  { value: 'se', label: 'Sweden' },
  { value: 'sg', label: 'Singapore' },
  { value: 'si', label: 'Slovenia' },
  { value: 'sk', label: 'Slovakia' },
  { value: 'sv', label: 'El Salvador' },
  { value: 'th', label: 'Thailand' },
  { value: 'tn', label: 'Tunisia' },
  { value: 'tr', label: 'Turkey' },
  { value: 'tw', label: 'Taiwan' },
  { value: 'ua', label: 'Ukraine' },
  { value: 'us', label: 'United States' },
  { value: 'uy', label: 'Uruguay' },
  { value: 'uz', label: 'Uzbekistan' },
  { value: 've', label: 'Venezuela' },
  { value: 'vn', label: 'Vietnam' },
  { value: 'ye', label: 'Yemen' },
  { value: 'za', label: 'South Africa' },
  { value: 'zw', label: 'Zimbabwe' },
];

export const countries = [
  { value: '', label: 'Any Location' },
  { value: 'af', label: 'Afghanistan' },
  { value: 'al', label: 'Albania' },
  { value: 'dz', label: 'Algeria' },
  { value: 'as', label: 'American Samoa' },
  { value: 'ad', label: 'Andorra' },
  { value: 'ao', label: 'Angola' },
  { value: 'ai', label: 'Anguilla' },
  { value: 'aq', label: 'Antarctica' },
  { value: 'ag', label: 'Antigua and Barbuda' },
  { value: 'ar', label: 'Argentina' },
  { value: 'am', label: 'Armenia' },
  { value: 'aw', label: 'Aruba' },
  { value: 'au', label: 'Australia' },
  { value: 'at', label: 'Austria' },
  { value: 'az', label: 'Azerbaijan' },
  { value: 'bs', label: 'Bahamas' },
  { value: 'bh', label: 'Bahrain' },
  { value: 'bd', label: 'Bangladesh' },
  { value: 'bb', label: 'Barbados' },
  { value: 'by', label: 'Belarus' },
  { value: 'be', label: 'Belgium' },
  { value: 'bz', label: 'Belize' },
  { value: 'bj', label: 'Benin' },
  { value: 'bm', label: 'Bermuda' },
  { value: 'bt', label: 'Bhutan' },
  { value: 'bo', label: 'Bolivia' },
  { value: 'bq', label: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'ba', label: 'Bosnia and Herzegovina' },
  { value: 'bw', label: 'Botswana' },
  { value: 'bv', label: 'Bouvet Island' },
  { value: 'br', label: 'Brazil' },
  { value: 'io', label: 'British Indian Ocean Territory' },
  { value: 'bn', label: 'Brunei Darussalam' },
  { value: 'bg', label: 'Bulgaria' },
  { value: 'bf', label: 'Burkina Faso' },
  { value: 'bi', label: 'Burundi' },
  { value: 'kh', label: 'Cambodia' },
  { value: 'cm', label: 'Cameroon' },
  { value: 'ca', label: 'Canada' },
  { value: 'cv', label: 'Cape Verde' },
  { value: 'ky', label: 'Cayman Islands' },
  { value: 'cf', label: 'Central African Republic' },
  { value: 'td', label: 'Chad' },
  { value: 'cl', label: 'Chile' },
  { value: 'cn', label: 'China' },
  { value: 'cx', label: 'Christmas Island' },
  { value: 'cc', label: 'Cocos (Keeling) Islands' },
  { value: 'co', label: 'Colombia' },
  { value: 'km', label: 'Comoros' },
  { value: 'cg', label: 'Congo' },
  { value: 'cd', label: 'Congo, the Democratic Republic of the' },
  { value: 'ck', label: 'Cook Islands' },
  { value: 'cr', label: 'Costa Rica' },
  { value: 'ci', label: 'Cote D`ivoire' },
  { value: 'hr', label: 'Croatia' },
  { value: 'cu', label: 'Cuba' },
  { value: 'cw', label: 'Curaçao' },
  { value: 'cy', label: 'Cyprus' },
  { value: 'cz', label: 'Czech Republic' },
  { value: 'dk', label: 'Denmark' },
  { value: 'dj', label: 'Djibouti' },
  { value: 'dm', label: 'Dominica' },
  { value: 'do', label: 'Dominican Republic' },
  { value: 'ec', label: 'Ecuador' },
  { value: 'eg', label: 'Egypt' },
  { value: 'sv', label: 'El Salvador' },
  { value: 'gq', label: 'Equatorial Guinea' },
  { value: 'er', label: 'Eritrea' },
  { value: 'ee', label: 'Estonia' },
  { value: 'et', label: 'Ethiopia' },
  { value: 'fk', label: 'Falkland Islands (Malvinas)' },
  { value: 'fo', label: 'Faroe Islands' },
  { value: 'fj', label: 'Fiji' },
  { value: 'fi', label: 'Finland' },
  { value: 'fr', label: 'France' },
  { value: 'gf', label: 'French Guiana' },
  { value: 'pf', label: 'French Polynesia' },
  { value: 'tf', label: 'French Southern Territories' },
  { value: 'ga', label: 'Gabon' },
  { value: 'gm', label: 'Gambia' },
  { value: 'ge', label: 'Georgia' },
  { value: 'de', label: 'Germany' },
  { value: 'gh', label: 'Ghana' },
  { value: 'gi', label: 'Gibraltar' },
  { value: 'gr', label: 'Greece' },
  { value: 'gl', label: 'Greenland' },
  { value: 'gd', label: 'Grenada' },
  { value: 'gp', label: 'Guadeloupe' },
  { value: 'gu', label: 'Guam' },
  { value: 'gt', label: 'Guatemala' },
  { value: 'gn', label: 'Guinea' },
  { value: 'gw', label: 'Guinea-Bissau' },
  { value: 'gy', label: 'Guyana' },
  { value: 'ht', label: 'Haiti' },
  { value: 'hm', label: 'Heard Island and Mcdonald Islands' },
  { value: 'va', label: 'Holy See (Vatican City State)' },
  { value: 'hn', label: 'Honduras' },
  { value: 'hk', label: 'Hong Kong' },
  { value: 'hu', label: 'Hungary' },
  { value: 'is', label: 'Iceland' },
  { value: 'in', label: 'India' },
  { value: 'id', label: 'Indonesia' },
  { value: 'ir', label: 'Iran, Islamic Republic of' },
  { value: 'iq', label: 'Iraq' },
  { value: 'ie', label: 'Ireland' },
  { value: 'il', label: 'Israel' },
  { value: 'it', label: 'Italy' },
  { value: 'jm', label: 'Jamaica' },
  { value: 'jp', label: 'Japan' },
  { value: 'jo', label: 'Jordan' },
  { value: 'kz', label: 'Kazakhstan' },
  { value: 'ke', label: 'Kenya' },
  { value: 'ki', label: 'Kiribati' },
  { value: 'kp', label: 'Korea, Democratic People`s Republic of' },
  { value: 'kr', label: 'Korea, Republic of' },
  { value: 'kw', label: 'Kuwait' },
  { value: 'kg', label: 'Kyrgyzstan' },
  { value: 'la', label: 'Lao People`s Democratic Republic' },
  { value: 'lv', label: 'Latvia' },
  { value: 'lb', label: 'Lebanon' },
  { value: 'ls', label: 'Lesotho' },
  { value: 'lr', label: 'Liberia' },
  { value: 'ly', label: 'Libyan Arab Jamahiriya' },
  { value: 'li', label: 'Liechtenstein' },
  { value: 'lt', label: 'Lithuania' },
  { value: 'lu', label: 'Luxembourg' },
  { value: 'mo', label: 'Macao' },
  { value: 'mk', label: 'Macedonia, the Former Yugosalv Republic of' },
  { value: 'mg', label: 'Madagascar' },
  { value: 'mw', label: 'Malawi' },
  { value: 'my', label: 'Malaysia' },
  { value: 'mv', label: 'Maldives' },
  { value: 'ml', label: 'Mali' },
  { value: 'mt', label: 'Malta' },
  { value: 'mh', label: 'Marshall Islands' },
  { value: 'mq', label: 'Martinique' },
  { value: 'mr', label: 'Mauritania' },
  { value: 'mu', label: 'Mauritius' },
  { value: 'yt', label: 'Mayotte' },
  { value: 'mx', label: 'Mexico' },
  { value: 'fm', label: 'Micronesia, Federated States of' },
  { value: 'md', label: 'Moldova, Republic of' },
  { value: 'mc', label: 'Monaco' },
  { value: 'mn', label: 'Mongolia' },
  { value: 'me', label: 'Montenegro' },
  { value: 'ms', label: 'Montserrat' },
  { value: 'ma', label: 'Morocco' },
  { value: 'mz', label: 'Mozambique' },
  { value: 'mm', label: 'Myanmar' },
  { value: 'na', label: 'Namibia' },
  { value: 'nr', label: 'Nauru' },
  { value: 'np', label: 'Nepal' },
  { value: 'nl', label: 'Netherlands' },
  { value: 'nc', label: 'New Caledonia' },
  { value: 'nz', label: 'New Zealand' },
  { value: 'ni', label: 'Nicaragua' },
  { value: 'ne', label: 'Niger' },
  { value: 'ng', label: 'Nigeria' },
  { value: 'nu', label: 'Niue' },
  { value: 'nf', label: 'Norfolk Island' },
  { value: 'mp', label: 'Northern Mariana Islands' },
  { value: 'no', label: 'Norway' },
  { value: 'om', label: 'Oman' },
  { value: 'pk', label: 'Pakistan' },
  { value: 'pw', label: 'Palau' },
  { value: 'ps', label: 'Palestinian Territory, Occupied' },
  { value: 'pa', label: 'Panama' },
  { value: 'pg', label: 'Papua New Guinea' },
  { value: 'py', label: 'Paraguay' },
  { value: 'pe', label: 'Peru' },
  { value: 'ph', label: 'Philippines' },
  { value: 'pn', label: 'Pitcairn' },
  { value: 'pl', label: 'Poland' },
  { value: 'pt', label: 'Portugal' },
  { value: 'pr', label: 'Puerto Rico' },
  { value: 'qa', label: 'Qatar' },
  { value: 're', label: 'Reunion' },
  { value: 'ro', label: 'Romania' },
  { value: 'ru', label: 'Russian Federation' },
  { value: 'rw', label: 'Rwanda' },
  { value: 'sh', label: 'Saint Helena' },
  { value: 'kn', label: 'Saint Kitts and Nevis' },
  { value: 'lc', label: 'Saint Lucia' },
  { value: 'pm', label: 'Saint Pierre and Miquelon' },
  { value: 'vc', label: 'Saint Vincent and the Grenadines' },
  { value: 'ws', label: 'Samoa' },
  { value: 'sm', label: 'San Marino' },
  { value: 'st', label: 'Sao Tome and Principe' },
  { value: 'sa', label: 'Saudi Arabia' },
  { value: 'sn', label: 'Senegal' },
  { value: 'rs', label: 'Serbia' },
  { value: 'sc', label: 'Seychelles' },
  { value: 'sl', label: 'Sierra Leone' },
  { value: 'sg', label: 'Singapore' },
  { value: 'sx', label: 'Sint Maarten' },
  { value: 'sk', label: 'Slovakia' },
  { value: 'si', label: 'Slovenia' },
  { value: 'sb', label: 'Solomon Islands' },
  { value: 'so', label: 'Somalia' },
  { value: 'za', label: 'South Africa' },
  { value: 'gs', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'es', label: 'Spain' },
  { value: 'lk', label: 'Sri Lanka' },
  { value: 'sd', label: 'Sudan' },
  { value: 'sr', label: 'Suriname' },
  { value: 'sj', label: 'Svalbard and Jan Mayen' },
  { value: 'sz', label: 'Swaziland' },
  { value: 'se', label: 'Sweden' },
  { value: 'ch', label: 'Switzerland' },
  { value: 'sy', label: 'Syrian Arab Republic' },
  { value: 'tw', label: 'Taiwan, Province of China' },
  { value: 'tj', label: 'Tajikistan' },
  { value: 'tz', label: 'Tanzania, United Republic of' },
  { value: 'th', label: 'Thailand' },
  { value: 'tl', label: 'Timor-Leste' },
  { value: 'tg', label: 'Togo' },
  { value: 'tk', label: 'Tokelau' },
  { value: 'to', label: 'Tonga' },
  { value: 'tt', label: 'Trinidad and Tobago' },
  { value: 'tn', label: 'Tunisia' },
  { value: 'tr', label: 'Turkey' },
  { value: 'tm', label: 'Turkmenistan' },
  { value: 'tc', label: 'Turks and Caicos Islands' },
  { value: 'tv', label: 'Tuvalu' },
  { value: 'ug', label: 'Uganda' },
  { value: 'ua', label: 'Ukraine' },
  { value: 'ae', label: 'United Arab Emirates' },
  { value: 'gb', label: 'United Kingdom' },
  { value: 'us', label: 'United States' },
  { value: 'um', label: 'United States Minor Outlying Islands' },
  { value: 'uy', label: 'Uruguay' },
  { value: 'uz', label: 'Uzbekistan' },
  { value: 'vu', label: 'Vanuatu' },
  { value: 've', label: 'Venezuela' },
  { value: 'vn', label: 'Viet Nam' },
  { value: 'vg', label: 'Virgin Islands, British' },
  { value: 'vi', label: 'Virgin Islands, U.S.' },
  { value: 'wf', label: 'Wallis and Futuna' },
  { value: 'eh', label: 'Western Sahara' },
  { value: 'ye', label: 'Yemen' },
  { value: 'zm', label: 'Zambia' },
  { value: 'zw', label: 'Zimbabwe' },
];
